import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { loginWithLink } from '../../actions';
import { AuthPage } from '../../components';
import Box from '../../components/layout/Box';
import { getAuthState } from '../../selectors';

class ForgotPasswordConfirmPage extends React.Component {
  static propTypes = {
    loginWithLink: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    authState: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({error: nextProps.authState.error});
  }

  componentDidMount(){
    
        const {code} = this.props.match.params;
    
        this.props.loginWithLink(code);
     
  }

  render() {
    return (
      <AuthPage heading="Login">
        <div className="error" style={{display: 'flex', height: '75px', alignItems: 'center', justifyContent: 'center'}}>
            {!this.props.authState.error && <div style={{color: 'green'}}>Please wait while we log you in!</div>}
            {this.props.authState.error}
        </div>
          
       
      </AuthPage>
    );
  }
}

export default connect((state) => ({
    authState: getAuthState(state),
  }), {
    loginWithLink,
  },
)(ForgotPasswordConfirmPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/LoginLink/index.js